import {Endpoint} from '@eryxcoop/appyx-comm';

export default class SendPaymentReminderEndpoint extends Endpoint {

    adaptValues({taxpayerIdentificationNumber, message}) {
        return {
            taxpayer_identification_number: taxpayerIdentificationNumber,
            message: message,
        }
    }
}
